// extracted by mini-css-extract-plugin
export default {"bannerCard_container":"bannerCard_bannerCard_container__GBpcB","bannerCard":"bannerCard_bannerCard__S6b6Z","image":"bannerCard_image__g1S6Z"};